var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "coupon-form" }, [
    _vm.appliedCouponCode != null
      ? _c(
          "div",
          { staticClass: "applied-coupon-section" },
          [
            _c(
              "v-card",
              { staticClass: "applied-coupon-card", attrs: { outlined: "" } },
              [
                _c("v-card-text", { staticClass: "pa-3" }, [
                  _c(
                    "div",
                    {
                      staticClass: "d-flex justify-space-between align-center",
                    },
                    [
                      _c("div", { staticClass: "flex-grow-1" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-center mb-1" },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "mr-1",
                                attrs: { small: "", color: "primary" },
                              },
                              [_vm._v("mdi-ticket-confirmation")]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "fs-13 fw-600" }, [
                              _vm._v(_vm._s(_vm.appliedCouponCode)),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.appliedCouponDetails
                          ? _c("div", { staticClass: "fs-12 opacity-60" }, [
                              _vm.appliedCouponDetails.name
                                ? _c("span", { staticClass: "d-block" }, [
                                    _vm._v(
                                      _vm._s(_vm.appliedCouponDetails.name)
                                    ),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.appliedCouponDetails.type === "percentage"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.appliedCouponDetails.discount_value
                                      ) +
                                        "% " +
                                        _vm._s(_vm.$t("discount"))
                                    ),
                                  ])
                                : _vm.appliedCouponDetails.discount_value
                                ? _c("span", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.formatPrice(
                                            _vm.appliedCouponDetails
                                              .discount_value
                                          )
                                        ) +
                                        " " +
                                        _vm._s(_vm.$t("discount")) +
                                        "\n                            "
                                    ),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _vm.appliedCouponDiscount > 0
                            ? _c("div", { staticClass: "text-right mr-3" }, [
                                _c(
                                  "div",
                                  { staticClass: "fs-14 fw-700 primary--text" },
                                  [
                                    _vm._v(
                                      "-" +
                                        _vm._s(
                                          _vm.formatPrice(
                                            _vm.appliedCouponDiscount
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "white--text darken-3 text-capitalize px-3",
                              attrs: {
                                elevation: "0",
                                color: "grey",
                                small: "",
                              },
                              on: { click: _vm.removeCoupon },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("change")) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "coupon-selection-section" },
          [
            !_vm.showCouponList
              ? _c(
                  "v-row",
                  {
                    staticClass: "mt-0",
                    attrs: { dense: !_vm.forCheckout, align: "center" },
                  },
                  [
                    !_vm.forCheckout
                      ? _c(
                          "v-col",
                          {
                            staticClass:
                              "fs-13 fw-600 opacity-50 flex-shrink-0",
                            attrs: { cols: "auto" },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.$t("have_a_code")) +
                                "\n            "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "text-capitalize px-5",
                            attrs: {
                              elevation: "0",
                              color: "primary",
                              small: "",
                              loading: _vm.couponLoading,
                              disabled: _vm.couponLoading,
                            },
                            on: { click: _vm.loadAvailableCoupons },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("select_coupon")) +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass:
                              "white--text darken-3 text-capitalize px-3",
                            attrs: { elevation: "0", color: "grey", small: "" },
                            on: {
                              click: function ($event) {
                                _vm.showManualInput = true
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("enter_code")) +
                                "\n                "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showManualInput && !_vm.showCouponList
              ? _c(
                  "v-row",
                  {
                    staticClass: "mt-0",
                    attrs: { dense: !_vm.forCheckout, align: "center" },
                  },
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "fw-500 opacity-80",
                        attrs: { cols: _vm.forCheckout ? 8 : null },
                      },
                      [
                        _c("v-text-field", {
                          staticClass: "form-control form-control-sm white",
                          attrs: {
                            placeholder: _vm.$t("coupon_code"),
                            type: "text",
                            "hide-details": "auto",
                            required: "",
                            outlined: "",
                          },
                          model: {
                            value: _vm.couponCode,
                            callback: function ($$v) {
                              _vm.couponCode = $$v
                            },
                            expression: "couponCode",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      {
                        staticClass: "fw-700",
                        attrs: { cols: _vm.forCheckout ? 2 : "auto" },
                      },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass:
                              "white--text darken-3 text-capitalize px-3",
                            attrs: {
                              elevation: "0",
                              color: "grey",
                              small: "",
                              loading: _vm.couponLoading,
                              disabled: _vm.couponLoading,
                            },
                            on: { click: _vm.applyCoupon },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("apply")) +
                                "\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            staticClass:
                              "grey--text darken-3 text-capitalize px-2",
                            attrs: {
                              elevation: "0",
                              color: "grey",
                              small: "",
                              text: "",
                            },
                            on: {
                              click: function ($event) {
                                _vm.showManualInput = false
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("cancel")) +
                                "\n                "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showCouponList
              ? _c("div", { staticClass: "coupon-list mt-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-space-between align-center mb-3",
                    },
                    [
                      _c("h4", { staticClass: "fs-14 fw-600" }, [
                        _vm._v(_vm._s(_vm.$t("available_coupons"))),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "grey--text darken-3 text-capitalize",
                          attrs: {
                            elevation: "0",
                            color: "grey",
                            small: "",
                            text: "",
                          },
                          on: { click: _vm.closeCouponList },
                        },
                        [_vm._v(_vm._s(_vm.$t("close")))]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.availableCoupons.length > 0
                    ? _c(
                        "div",
                        { staticClass: "mb-3" },
                        [
                          _c(
                            "div",
                            { staticClass: "fs-12 fw-600 mb-2 opacity-70" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("can_use")) +
                                  " (" +
                                  _vm._s(_vm.availableCoupons.length) +
                                  ")"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.availableCoupons, function (coupon) {
                            return _c(
                              "v-card",
                              {
                                key: coupon.id,
                                staticClass: "coupon-card mb-2",
                                class: {
                                  "coupon-card--selected":
                                    _vm.selectedCoupon &&
                                    _vm.selectedCoupon.id === coupon.id,
                                },
                                attrs: { outlined: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.selectCoupon(coupon)
                                  },
                                },
                              },
                              [
                                _c("v-card-text", { staticClass: "pa-3" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "d-flex justify-space-between align-start",
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "flex-grow-1" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "fs-13 fw-600 mb-1",
                                            },
                                            [_vm._v(_vm._s(coupon.name))]
                                          ),
                                          _vm._v(" "),
                                          coupon.description
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "fs-12 opacity-70 mb-2",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(coupon.description)
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "fs-11 opacity-50" },
                                            [
                                              coupon.min_order_amount
                                                ? _c("span", [
                                                    _vm._v(
                                                      "최소 " +
                                                        _vm._s(
                                                          _vm.formatPrice(
                                                            coupon.min_order_amount
                                                          )
                                                        )
                                                    ),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              coupon.end_date
                                                ? _c(
                                                    "span",
                                                    { staticClass: "ml-2" },
                                                    [
                                                      _vm._v(
                                                        "~" +
                                                          _vm._s(
                                                            _vm.formatDate(
                                                              coupon.end_date
                                                            )
                                                          )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "text-right" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "fs-13 fw-700 primary--text",
                                          },
                                          [
                                            _vm._v(
                                              "-" +
                                                _vm._s(
                                                  _vm.formatPrice(
                                                    coupon.calculated_discount
                                                  )
                                                )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "fs-11 opacity-70" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                coupon.type === "percentage"
                                                  ? coupon.discount_value + "%"
                                                  : _vm.$t("fixed_amount")
                                              )
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.unavailableCoupons.length > 0
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            { staticClass: "fs-12 fw-600 mb-2 opacity-50" },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("cannot_use")) +
                                  " (" +
                                  _vm._s(_vm.unavailableCoupons.length) +
                                  ")"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.unavailableCoupons, function (coupon) {
                            return _c(
                              "v-card",
                              {
                                key: "unavailable-" + coupon.id,
                                staticClass: "coupon-card mb-2",
                                attrs: { outlined: "", disabled: "" },
                              },
                              [
                                _c(
                                  "v-card-text",
                                  { staticClass: "pa-3 opacity-50" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-space-between align-start",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex-grow-1" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "fs-13 fw-600 mb-1",
                                              },
                                              [_vm._v(_vm._s(coupon.name))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "fs-12 mb-2 red--text",
                                              },
                                              [_vm._v(_vm._s(coupon.reason))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "fs-11" },
                                              [
                                                coupon.min_order_amount
                                                  ? _c("span", [
                                                      _vm._v(
                                                        "최소 " +
                                                          _vm._s(
                                                            _vm.formatPrice(
                                                              coupon.min_order_amount
                                                            )
                                                          )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                coupon.end_date
                                                  ? _c(
                                                      "span",
                                                      { staticClass: "ml-2" },
                                                      [
                                                        _vm._v(
                                                          "~" +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                coupon.end_date
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "text-right" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "fs-13 fw-700" },
                                              [
                                                _vm._v(
                                                  "-" +
                                                    _vm._s(
                                                      _vm.formatPrice(
                                                        coupon.calculated_discount
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "fs-11" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    coupon.type === "percentage"
                                                      ? coupon.discount_value +
                                                          "%"
                                                      : _vm.$t("fixed_amount")
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.availableCoupons.length === 0 &&
                  _vm.unavailableCoupons.length === 0
                    ? _c(
                        "div",
                        { staticClass: "text-center py-4 opacity-70" },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("no_coupons_available")) +
                              "\n            "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedCoupon
                    ? _c(
                        "div",
                        { staticClass: "mt-3 pt-3 border-top" },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "white--text text-capitalize",
                                      attrs: {
                                        elevation: "0",
                                        color: "primary",
                                        block: "",
                                        loading: _vm.couponLoading,
                                        disabled: _vm.couponLoading,
                                      },
                                      on: { click: _vm.applySelectedCoupon },
                                    },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$t("apply_coupon")) +
                                          " (-" +
                                          _vm._s(
                                            _vm.formatPrice(
                                              _vm.selectedCoupon
                                                .calculated_discount
                                            )
                                          ) +
                                          ")\n                        "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ])
              : _vm._e(),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }